import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Banner from '../../components/banner.js';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import Sidebar from '../../components/sidebar.js';
import { getProductAutocomplete } from '../../Services/ProductSearchService'
import { getInteraction, getAllergyInteractions, getInteractionVP, getInteractionsDisclaimer } from '../../Services/IMGatewayInteractionService'
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams, useLocation } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { IconSearch, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, TextField, Checkbox, InputAdornment, CircularProgress, Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../../styles/DrugAllergyInteractions.scss'
import { logPageViews } from '../../Services/LoginService.js';
import InteractionsIllustration from '../../assets/ModuleIllustrations/DrugInteractions.svg';
import InteractionsIllustrationNZ from '../../assets/ModuleIllustrations/NZ/DrugInteractions.svg';
import { useThemeManager } from '../../Context/ThemeManager.js';

//import Pagination from 'react-bootstrap/Pagination';
const DrugAllergyInteractions = () => {
    const { theme} = useThemeManager();
    const history = useHistory();
    const [activeButton, setActiveButton] = useState('interactions');
    const search = useLocation().search;
    const params = new URLSearchParams(search);
    const [interId, SetinterId] = useState(params.get('id'))
    const [interName, SetinterName] = useState(params.get('name'))
    const [interType, SetinterType] = useState(params.get('type'))
    const [countPerPage] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const [totalCountAllergy, setTotalCountAllergy] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentAllergyPage, setCurrentAllergyPage] = useState(1);
    const totalPages = totalCount < countPerPage ? 1 : Math.ceil(totalCount / countPerPage)

    //vp
    const vp_interId = params.get('vp_id')
    const vp_interName = params.get('vp_name')
    const [PrescribedMedicines, setPrescribedMedicines] = useState([]);

    const [interactionResults, setInteractionResults] = useState([])
    const [interactionDisclaimer, setInteractionDisclaimer] = useState("")
    const [noInteractionDisclaimer, setNoInteractionDisclaimer] = useState("")
    const [AllergyResults, setAllergy] = useState([])
    const [allergyDisclaimer, setAllergyDisclaimer] = useState("")
    const [noAllergyDisclaimer, setNoAllergyDisclaimer] = useState("")
    const [isCountInter, setisCountInter] = useState(false);
    const [isCountAllergy, setisCountAllergy] = useState(false);

    const handleSearchNavigate = (event) => {
        setIsLoading(false)
        if (event !== null) {
            setInputs(event.map(val => ({ id: val.id, type: val.type, label: val.label })))
        }
    };

    const handleSearchChangeAllergies = (event) => {
        setIsLoading(false)
        if (event !== null) {
            setInputAllergy(event.map(val => ({ allergenId: val.id, allergenType: val.type, allergenName: val.label })))
            if(event[0]?.label?.toLowerCase().includes("sulfur")) setSulfurWarningModal(true)
        }
    }

    const [query, setQuery] = useState(interName);
    const [allergyQuery, setAllergyQuery] = useState('');
    const [inputs, setInputs] = useState([]);
    const [inputAllergy, setInputAllergy] = useState([]);
    const [isAllergyTabEnabled, setIsAllergyTabEnabled] = useState(false); //  Use state
    const [lastValidInputs, setLastValidInputs] = useState([]);
    const [lastValidAllergyInputs, setLastValidAllergyInputs] = useState([]);
    const [severityCounts, setSeverityCounts] = useState({ 5: 0, 4: 0, 3: 0, 2: 0 });
    const [documentationCounts, setDocumentationCounts] = useState({ 1: 0, 2: 0, 3: 0, 4: 0 });
    const [allInteractionResults, setAllInteractionResults] = useState([]);
    const country = localStorage.getItem("Activecountryversion");

    useEffect(() => {
        document.title = "Drug & Allergy Interactions"
        logPage("Interactions", "", "")
            document.documentElement.style.setProperty('--primary-color', theme.primary);
            document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
            document.documentElement.style.setProperty('--bg', theme.bg);
   }, [])
   



// useEffect(() => {
//     checkInteraction()
//     async function checkInteraction() {
//         if (vp_interId !== null) {
//             document.getElementById('loaderPage').style.display = 'flex'
//             setQuery(vp_interName)
//             setInputs([{ id: vp_interId, type: 'vp' }])
//             const interactInput = ([{ id: vp_interId, type: 'vp' }])
//             setInteractionResults(await getInteractionVP(interactInput, 1))
//             document.getElementById('loaderPage').style.display = 'none'
//         }
//     }
//     if (vp_interId !== null) {
//         console.log(vp_interName)
//         SetinterId(vp_interId)
//         SetinterName(vp_interName)
//         SetinterType('vp')
//     }

// }, [vp_interId]);

const hasRun = useRef(false);


useEffect(() => {
    if (hasRun.current) return; // stops running once the useEffect has triggered
    document.getElementById("loaderPage").style.display = "flex";
    if (!interId || !interName || !interType) {
        console.log("Waiting for valid route data:", { interId, interName, interType });
        setTimeout(() => {
            document.getElementById("loaderPage").style.display = "none";
          }, 500); 
        
        return;
    }

    const checkRedirectedInteraction = async () => {
        const firstWord = interName?.split?.(" ")?.[0] ?? "";
        console.log("unsplit label:", interName);
        console.log("first word:", firstWord);

        try {
            const data = await getProductAutocomplete(firstWord, 50, false, false, false);
            const matchedOption = data.find(opt => opt.id === interId);

            const input = matchedOption
            ? { id: matchedOption.id, label: parse(matchedOption.name) , type: interType }
            : { id: interId, label: interName, type: interType };
            //console.log("input: ", input)
            setSelectedMedicines([input]);
            handleSearchNavigate([input]); 
            
            CheckInteractionHandle([input]); // use direct input instead of waiting for state
            if (!isLgScreen) {
                requestAnimationFrame(() => {
                  handleScrollUp();
                });
              }
            hasRun.current = true;
        } catch (error) {
            console.error("Error during redirected interaction:", error);
        }
    };

    checkRedirectedInteraction();
}, [interId, interName, interType]);





    async function CheckInteractionHandle(forcedInputs = null) {
        const finalInputs = forcedInputs || inputs;
        if (finalInputs.length === 0) return;
        if (inputs?.length > 0) {
            document.getElementById("loaderPage").style.display = "flex";
        }
    
        setInteractionResults([]);
        setAllergy([]);
        setIsAllergyTabEnabled(false);
        setTabValue(0);
        setRowsPerPage(5);
        setIsSearchModalOpen(false);
        // Save last valid inputs before making a search
        if (finalInputs.length > 0) {
            setLastValidInputs(finalInputs);  // Store inputs for pagination recovery
            console.log("selected medicine: ", finalInputs)
            const results = await getInteractionVP(finalInputs, 1, 5);
            setInteractionResults(results);
          
              
            setIsFiltered(false);
            setFilteredResults([]);
            setCurrentPage(1);
            setTotalCount(results.count);
            console.log("🧐 Total count:", results.count);
             // Count severity levels and documentation levels dynamically
            const severityCounts = { 5: 0, 4: 0, 3: 0, 2: 0 };
            const documentationCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
             
            const resultsForFilters = await getInteractionVP(finalInputs, 1, results.count);
            const allInteractions = resultsForFilters?.data?.drugInteractions || [];

            setAllInteractionResults(allInteractions); // <-- This should be a useState
            // Now this is safe
            allInteractions.forEach((val) => {
            severityCounts[val.severityLevel] += 1;
            });

             
             // Step 2: Build severity filters and extract valid severities
             const validSeverities = [];
             const newSeverityFilters = {};
             [5, 4, 3, 2].forEach((level) => {
               const hasResults = severityCounts[level] > 0;
               newSeverityFilters[level] = hasResults;
               if (hasResults) validSeverities.push(level);
             });
             newSeverityFilters.all = validSeverities.length === 4;
             setSeverityFilters(newSeverityFilters);
             setAppliedSeverities(validSeverities);
             
             // Step 3: Count documentation levels based on valid severities
             allInteractions.forEach((val) => {
               if (validSeverities.includes(val.severityLevel)) {
                 documentationCounts[val.documentationLevel] += 1;
               }
             });
             
             // Step 4: Build documentation filters
             const validDocs = [];
             const newDocFilters = {};
             [1, 2, 3, 4].forEach((level) => {
               const hasResults = documentationCounts[level] > 0;
               newDocFilters[level] = hasResults;
               if (hasResults) validDocs.push(level);
             });
             newDocFilters.all = validDocs.length === 4;
             setDocumentationFilters(newDocFilters);
             setAppliedDocs(validDocs);
             
             // Step 5: Store counts in state for displaying next to checkboxes
             setSeverityCounts(severityCounts);
             setDocumentationCounts(documentationCounts);
             
            if (inputAllergy.length > 0) {
                console.log("Saving Last Valid Allergy Inputs:", inputAllergy);
    
                // Use a functional update to ensure state is correctly saved
                setLastValidAllergyInputs((prev) => {
                    console.log(" Updating Last Valid Allergy Inputs:", prev);
                    return inputAllergy;
                });
    
                const allergyResults = await getAllergyInteractions(finalInputs, inputAllergy, 1, 5);
                setAllergy(allergyResults);
                setIsAllergyTabEnabled(true);
                setTotalCountAllergy(allergyResults.count);
                setCurrentAllergyPage(1);
            }
        }
        
        document.getElementById("loaderPage").style.display = "none";
    }
    
    

    
    
    // Pagination
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
    const CustomPaginationActions = () => {
        return null; // This completely removes the navigation arrows
    };
   
    async function CheckPageInteractionHandleIndex(event, value, overrideRowsPerPage = null) {
        console.log("Fetching page:", value, "with rowsPerPage:", overrideRowsPerPage || rowsPerPage);
    
        document.getElementById("loaderPage").style.display = "flex";
        
        setCurrentPage(value);
    
        const fetchLimit = overrideRowsPerPage === -1 ? 99999 : overrideRowsPerPage || rowsPerPage;
        // Always fetch results based on the last valid search inputs (ignoring recent removals)
        const searchInputs = lastValidInputs; // Get stored medicine inputs
        const searchAllergyInputs = lastValidAllergyInputs; // Get stored allergy inputs
        setInputs(searchInputs);
        setSelectedMedicines(searchInputs); 
        setFilteredResults([]);
        if (!isFiltered){
        
            setInteractionResults([]);        
            const results = await getInteractionVP(searchInputs, value, fetchLimit);
            setInteractionResults(results);
            setTotalCount(results.count);
        }
        else {
            const activeRowsPerPage = overrideRowsPerPage ?? rowsPerPage;
            const startIndex = (value - 1) * activeRowsPerPage;
            const nextPaginatedResults = searchFilteredResults.slice(startIndex, startIndex + activeRowsPerPage);
        
            console.log(` Paginating from ${startIndex} to ${startIndex + activeRowsPerPage}`);
            console.log("Next page results:", nextPaginatedResults);
        
            setFilteredResults(nextPaginatedResults);
        }

        // Restore ALL original inputs in the autocomplete field (before any removals)
        if (AllergyResults && AllergyResults.count > 0) {  
            console.log(" Restoring Allergies from Previous Inputs:", searchAllergyInputs);

            const formattedAllergies = searchAllergyInputs.map(allergy => ({
                id: allergy.allergenId,
                label: allergy.allergenName,
                type: allergy.allergenType
            }));

            console.log(" Converted Allergies for Autocomplete:", formattedAllergies);

            setInputAllergy(searchAllergyInputs);
            setSelectedAllergy(formattedAllergies);
        } else {
            console.log(" Allergy results are empty, skipping restoration.");
        }
    
        document.getElementById("loaderPage").style.display = "none";
    }
    

    async function CheckPageAllergyHandleIndex(event, value, overrideRowsPerPage = null) {
        console.log("Fetching page:", value, "with rowsPerPage:", overrideRowsPerPage || rowsPerPage);
    
        document.getElementById("loaderPage").style.display = "flex";
        setAllergy([]);
        setCurrentAllergyPage(value);
    
        // If "All" is selected, pass a very large number (e.g., 99999) to fetch everything
        const fetchLimit = overrideRowsPerPage === -1 ? 99999 : overrideRowsPerPage || rowsPerPage;

        // Always fetch results based on the last valid search inputs (ignoring recent removals)
        const searchInputs = lastValidInputs;
        const searchAllergyInputs = lastValidAllergyInputs;  
    
        // Restore ALL original inputs in the autocomplete field (before any removals)
        setInputs(searchInputs);
        setSelectedMedicines(searchInputs); 

        console.log(" Restoring Allergies from Previous Inputs:", searchAllergyInputs);

        const formattedAllergies = searchAllergyInputs.map(allergy => ({
            id: allergy.allergenId,
            label: allergy.allergenName,
            type: allergy.allergenType
        }));

        console.log(" Converted Allergies for Autocomplete:", formattedAllergies);

        setInputAllergy(searchAllergyInputs);
        setSelectedAllergy(formattedAllergies);
    
        const results = await getAllergyInteractions(searchInputs, searchAllergyInputs, value, fetchLimit);
        setAllergy(results);
        setTotalCountAllergy(results.count); // Update total count
    
        document.getElementById("loaderPage").style.display = "none";
    }
    

    async function logPage(pageName, input1, input2) {
        await logPageViews(pageName
            , input1
            , input2
        )
    }


    

    useEffect(() => {
        setCurrentPage(interactionResults.page)
        setTotalCount(interactionResults.count)
        if (interactionResults.data?.noInteractionDisclaimer != "") {
            getInteractionsDisclaimer(interactionResults.data?.noInteractionDisclaimer)
                .then(e => { setNoInteractionDisclaimer(e.disclaimer) })
        }
        else setNoInteractionDisclaimer("")

        getInteractionsDisclaimer(interactionResults.data?.generalDisclaimer)
            .then(e => setInteractionDisclaimer(e.disclaimer))

        setCurrentAllergyPage(AllergyResults.page)
        setTotalCountAllergy(AllergyResults.count)
        //console.log(interactionResults.count !== 'undefined')
        setTotalCountAllergy(AllergyResults.count)
        if (AllergyResults.data?.noAllergyDisclaimer != "") {
            getInteractionsDisclaimer(AllergyResults.data?.noAllergyDisclaimer)
                .then(e => setNoAllergyDisclaimer(e.disclaimer))
        }
        else setNoAllergyDisclaimer("")

        getInteractionsDisclaimer(AllergyResults.data?.generalDisclaimer)
            .then(e => setAllergyDisclaimer(e.disclaimer))

    }, [interactionResults, AllergyResults])

    useEffect(() => {
        setCurrentPage(currentPage)
    }, [currentPage])
    useEffect(() => {
        setCurrentAllergyPage(currentAllergyPage)
    }, [currentAllergyPage])

    const [InteractionShow, setInteractionShow] = useState(false);
    const [AllergymodalShow, setAllergyModalShow] = useState(false);
    const [sulfurWarningModal, setSulfurWarningModal] = useState(false)
    const [severityLevel, setseverityLevel] = useState('');
    const [severityLevelName, setseverityLevelName] = useState('');
    const [documentationLevel, setdocumentationLevel] = useState('');
    const [documentationLevelName, setdocumentationLevelName] = useState('');
    const [molecule, setmolecule] = useState('');
    const [interactingMolecule, setinteractingMolecule] = useState('');
    const [observation, setobservation] = useState('');
    const [className1, setClassName1] = useState('');
    const [className2, setClassName2] = useState('');
    const [classDescription1, setclassDescription1] = useState('');
    const [classDescription2, setclassDescription2] = useState('');
    const [precaution, setprecaution] = useState('');
    const [drugInteractionDetails, setdrugInteractionDetails] = useState('');
    const [references, setreferences] = useState([]);
    const [route1, setRoute1] = useState('');
    const [route2, setRoute2] = useState('');

    

    function tagNames(input) {
        return input
            .replace(molecule, '<span class="molecule">' + (molecule) + ' </span>')
            .replace(interactingMolecule, '<span class="interactingMolecule">' + (interactingMolecule) + ' </span>')
            .replace(className1 + ' class', '<span class="mimsclass">' + (className1) + '</span> class')
            .replace(className2 + ' class', '<span class="mimsclass">' + (className2) + '</span> class')
    }

    function InteractionModal(props) {
        return (

            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="resultsModal"
                dialogClassName={isLgScreen ? "" : "modal-dialog-scrollable"}
            >
                <Modal.Header closeButton >
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100">
                        <img src="/Drugs4dent.svg" id="logo-img" alt="Logo" className="me-2" style={{ maxWidth: isLgScreen ? "140px" : "100px", height: "auto" }} />
                        <h5 className="mb-0">Drug Interactions</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='mb-3'>
                        <Col lg={8} md={12} className={isLgScreen ? "mb-3" : "mb-3 p-0"}>
                        {isLgScreen ? (
                            <h4>
                            {molecule}
                            <span className="text-danger mx-2"> ⭤ </span>
                            {interactingMolecule}
                            </h4>
                        ) : (
                            <strong style={{fontSize: 18, color: "#0262AB" }}>
                            {molecule} <em style={{ color: "#727272" }}>({route1})</em>
                            <strong className="text-danger mx-2">⭤</strong>
                            {interactingMolecule} <em style={{ color: "#727272" }}>({route2})</em>
                            </strong>
                        )}
                        </Col>
                        <Col lg={4} md={12}>
                            {isLgScreen ? (
                            <List>
                                <ListItem >
                                    <ListItemText primary="Severity:" />
                                    <ListItemIcon >
                                    <Chip label={severityLevelName} color={getSeverityColor(severityLevel)} 
                                    sx={{ width: "124px", borderWidth: "3px", borderStyle: "solid",  borderColor: getSeverityColor(severityLevel, true), fontWeight: "bold", textAlign: "center"}}/>
                                    </ListItemIcon>
                                </ListItem>
                                <ListItem >
                                    <ListItemText primary="Documentation:" />
                                    <ListItemIcon>
                                        <Chip label={documentationLevelName} color={getDocLevelColor(documentationLevel)}  variant="outlined"
                                        sx={{width: "124px", borderWidth: "3px", borderStyle: "solid", fontWeight: "bold", textAlign: "center"}} />
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            ) : (
                            <Row>
                                <Col style={{width: "100%", padding: 0, paddingRight:"4px"}}>
                                    <Chip label={severityLevelName} color={getSeverityColor(severityLevel)} 
                                    sx={{ width: "100%", borderWidth: "3px", borderStyle: "solid",  borderColor: getSeverityColor(severityLevel, true), fontWeight: "bold", textAlign: "center"}}/>
                                </Col>
                            
                                <Col style={{width: "100%", padding: 0, paddingLeft:"4px"}}>
                                    <Chip label={documentationLevelName} color={getDocLevelColor(documentationLevel)}  variant="outlined"
                                        sx={{width: "100%", borderWidth: "3px", borderStyle: "solid", fontWeight: "bold", textAlign: "center"}} />
                                </Col>
                            </Row>
                            )}
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col lg={12} className={isLgScreen ? "interactionDetails mb-3" : "interactionDetails p-0"}>
                       
                            <div
                            className="d-flex my-2 p-0"
                            style={{ flexDirection: isLgScreen ? "column" : "row" }}
                            >
                            {!isLgScreen ? (
                                <><Col md={2} className='me-3 align-content-center'>
                                <IconInfoTriangleFilled size={32} style={{ color: '#D32F2F' }} className="me-2" /></Col>
                                <Col md={10}>
                                <span style={{fontSize: "14px", fontWeight: "bold"}}>
                                    {observation}
                                </span>
                                </Col>
                                </>
                            ) : (
                                <>
                                <strong className="mb-1">Interaction effect</strong>
                                <span>
                                <IconInfoTriangleFilled style={{ color: '#D32F2F' }} className="me-2" />
                                    {parse(tagNames(observation))}
                                </span>
                                </>
                            )}
                            </div>

                            <div className="d-flex flex-column my-3">
                                <strong>Actions to be taken</strong>
                                <ul style={{ listStyleType: "none", paddingLeft: isLgScreen ? 16 : 0 }}>
                                    {precaution.split('<BR>').map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className='d-flex flex-column my-3'>
                                <strong>Drug interactions details</strong>
                                <span>{drugInteractionDetails}</span>
                            </div>
                            <div className='d-flex flex-column my-3'>
                                <strong>References</strong>
                                <ul style={{ paddingLeft: isLgScreen ? 32 : 16 }}>
                                    {references.map((item, index) => {
                                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                                        const parts = item.split(urlRegex);
                                    
                                        return (
                                            <li key={index}>
                                                {parts.map((part, i) => {
                                                    // Detect URL and clean up the period at the end
                                                    const isUrl = urlRegex.test(part);
                                                    const cleanedUrl = isUrl ? part.replace(/[.,!?;]$/, '') : part; // Remove punctuation at the end
                                                    const displayText = isUrl ? part : cleanedUrl;

                                                    return isUrl ? (
                                                        <a
                                                            key={i}
                                                            href={cleanedUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ wordBreak: 'break-all' }}
                                                        >
                                                            {displayText}
                                                        </a>
                                                    ) : (
                                                        <span key={i}>{displayText}</span>
                                                    );
                                                })}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                            <div className='d-flex flex-column my-3'>
                                <strong>Description of classes</strong>
                                <ul style={{ paddingLeft: isLgScreen ? 32 : 16 }}>
                                    <li>{parse(tagNames(classDescription1))}</li>
                                    <li>{parse(tagNames(classDescription2))}</li>
                                </ul>
                            </div>   
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    const [summaryStatement, setsummaryStatement] = useState('');
    const [AllergyReference, setAllergyReference] = useState([]);
    function AllergyModal(props) {
        return (

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="resultsModal"
            >
                <Modal.Header closeButton >
                    
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100">
                        <img src="/Drugs4dent.svg" id="logo-img" alt="Logo" className="me-2" style={{ maxWidth: isLgScreen ? "140px" : "100px", height: "auto" }} />
                        <h5 className="mb-0">Allergy Check</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='mb-3'>
                        <Col lg={12} className={isLgScreen ? "mb-3" : "mb-3 p-0"}>
                        <div className='d-flex flex-column my-3'>
                        {isLgScreen ? (
                            <h4>
                            {molecule}
                            <span className="text-danger mx-2"> ⭤ </span>
                            {interactingMolecule}
                            </h4>
                        ) : (
                            <strong style={{fontSize: 18, color: "#202020"}}>
                            {molecule}
                            <strong className="text-danger mx-2">⭤</strong>
                            {interactingMolecule} 
                            </strong>
                        )}
                        </div>
                        <div className='d-flex flex-column my-3'>
                            <strong>Allergy interaction details</strong>
                            <span>
                                <IconInfoTriangleFilled style={{ color: '#D32F2F' }} className="me-2" />
                                {cleanUp(summaryStatement)}
                            </span>
                        </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
    const handleTxtValueInteraction = (severityLevel, severityLevelName, documentationLevel, documentationLevelName,
        molecule, interactingMolecule, observation, className1, classDescription1, className2, classDescription2, precaution, drugInteractionDetails, references, route1, route2
    ) => {


        setseverityLevel(severityLevel)
        setseverityLevelName(severityLevelName)
        setdocumentationLevel(documentationLevel)
        setdocumentationLevelName(documentationLevelName)
        setmolecule(molecule)
        setinteractingMolecule(interactingMolecule)
        setobservation(observation)
        setClassName1(className1)
        setclassDescription1(classDescription1)
        setClassName2(className2)
        setclassDescription2(classDescription2)
        setprecaution(precaution)
        setdrugInteractionDetails(drugInteractionDetails)
        setreferences(references)
        setInteractionShow(true)
        setRoute1(route1)
        setRoute2(route2)
        logPage("Interaction Details", molecule, interactingMolecule)

    };

    const handleTxtValueAllergy = (molecule, interactingMolecule, summaryStatement, references) => {
        setmolecule(molecule)
        setinteractingMolecule(interactingMolecule)
        setsummaryStatement(summaryStatement)
        setAllergyReference(references)
        setAllergyModalShow(true)
        logPage("Allergy Details", molecule, interactingMolecule)
    };

    function cleanUp(input) {
        input = input.replace('contains molecule', 'contains')
        input = input.replace('containing:', 'containing ')
        return parse(input)
    }

   


    function OnClickClear() {
        setPrescribedMedicines([])
        setInputs([])
        setInputAllergy([])
        setQuery('')
        setInteractionResults([])
        setAllergy([])
        SetinterId(null)
        SetinterName(null)
        SetinterType(null)

        if (params.get("id") != null && params.get("id") != "" ) {
             history.push('/druginteractions')
             window.location.reload();
            } else {
            window.location.reload();
        }
        //
    }


    function generalDisclaimer(text) {
        return (
            <div
                className={isLgScreen ? "notes mt-4" : "notes mt-1 "}
            >
                {text !== '' &&
                    parse(`<p>
                        ${isLgScreen ? "<span style='color: red; font-weight: bold;'>Disclaimer: </span>" : ""}
                        ${text?.split("<br />").join("</p><p>")}
                    </p>`)
                }
            </div>
        );
    }
    

    useEffect(() => {
        async function fetchData() {
            if (query && query.length > 2) {
                setIsLoading(true); // Show loading state
                try {
                    const data = await getProductAutocomplete(query, '10', false, false, false);
                    const formattedData = data?.map(items => ({
                        id: items.id,
                        type: items.type,
                        label: parse(items.name) ,
                    })) || []; // Ensure always an array
    
                    setPrescribedMedicines(formattedData);
    
                    // Ensure options are fully empty when no matches
                    if (!data || data.length === 0) {
                        setPrescribedMedicines([]); // Force empty state
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    setPrescribedMedicines([]); // Ensure no options if error occurs
                } finally {
                    setIsLoading(false); // Stop loading state
                }
            } else {
                setPrescribedMedicines([]); // Clear options when query is too short
            }
        }
    
        fetchData();
    }, [query]);
    
    useEffect(() => {
        async function fetchData() {
            if (allergyQuery && allergyQuery.length > 2) {
                setIsLoading(true); // Show loading state
                try {
                    const data = await getProductAutocomplete(allergyQuery, '10', true, false, false);
                    const formattedData = data?.map(items => ({
                        id: items.id,
                        type: items.type,
                        label: parse(items.name) ,
                    })) || []; // Ensure always an array
                  
                    setPrescribedMedicines(formattedData);
    
                    // Ensure options are fully empty when no matches
                    if (!data || data.length === 0) {
                        setPrescribedMedicines([]); // Force empty state
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    setPrescribedMedicines([]); // Ensure no options if error occurs
                } finally {
                    setIsLoading(false); // Stop loading state
                }
            } else {
                setPrescribedMedicines([]); // Clear options when query is too short
            }
        }
    
        fetchData();
    }, [allergyQuery]);

   
    const [isLoading, setIsLoading]= useState(false)

    //Input storage
    const [selectedMedicines, setSelectedMedicines] = useState([]);
    const [selectedAllergy, setSelectedAllergy] = useState([]);

    //Tabs
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    //Severity
    const getSeverityColor = (severityLevel, isBorder = false) => {
        switch (severityLevel) {
          case 5: return isBorder ? "#d32f2f" : "error";    // Red
          case 4: return isBorder ? "#ed6c02" : "warning";  // Orange
          case 3: return isBorder ? "#2e7d32" : "success";  // Green
          case 2: return isBorder ? "#1976d2" : "primary";  // Blue
          default: return isBorder ? "#727272" : "default"; // Gray (default MUI color)
        }
      };
    //Documentation Level
    const getDocLevelColor = (level) => {
    switch (level) {
        case 1: return "error";
        case 2: return "warning";
        case 3: return "success";
        case 4: return "primary";
        default: return "default"; // Fallback color
    }
    };
    //console.log(interactionResults)

    //Make search filters float after scrolling
    const [isFloating, setIsFloating] = useState(false);
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    useEffect(() => {
        const handleScroll = () => {
            
    
            if (window.scrollY > 132 && isLgScreen) {
                setIsFloating(true);
            } else if (window.scrollY < 100 && isLgScreen) {
                if (isFloating) setIsFloating(false);
            }
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isFloating]); // Watch for changes in isFloating
    const handleScrollUp = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };
    const sentinelRef = useRef(null);
    const [isTabsFloating, setIsTabsFloating] = useState(false);
    useEffect(() => {

            if (isLgScreen){
            setIsTabsFloating(false);
            return;
            } 
        
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsTabsFloating(!entry.isIntersecting);
            },
            {
                root: null,
                threshold: 0,
            }
            );
    
            if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
            }
    
            return () => {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
            };
            
            
        }, [isLgScreen]);

    const [severityFilters, setSeverityFilters] = useState({
      all: true,
      5: true,
      4: true,
      3: true,
      2: true
    });
    const [documentationFilters, setDocumentationFilters] = useState({
      all: true,
      4: true,
      3: true,
      2: true,
      1: true
    });
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);
    
    const handleOpenFilterDialog = () => {
        // Step 1: Restore severity checkbox states
        const newSeverityFilters = {
          5: appliedSeverities.includes(5),
          4: appliedSeverities.includes(4),
          3: appliedSeverities.includes(3),
          2: appliedSeverities.includes(2),
        };
        newSeverityFilters.all = appliedSeverities.length === 4;
        setSeverityFilters(newSeverityFilters);
      
        // Step 2: Recalculate documentation counts based on restored severities
        const updatedDocCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
        allInteractionResults.forEach((result) => {
          if (appliedSeverities.includes(result.severityLevel)) {
            updatedDocCounts[result.documentationLevel] += 1;
          }
        });
        setDocumentationCounts(updatedDocCounts);
      
        // Step 3: Restore documentation checkmarks & disabled states
        const newDocFilters = {
          1: appliedDocs.includes(1) && updatedDocCounts[1] > 0,
          2: appliedDocs.includes(2) && updatedDocCounts[2] > 0,
          3: appliedDocs.includes(3) && updatedDocCounts[3] > 0,
          4: appliedDocs.includes(4) && updatedDocCounts[4] > 0,
        };
        newDocFilters.all = [1, 2, 3, 4].every((key) => newDocFilters[key]);
        setDocumentationFilters(newDocFilters);
      
        // Step 4: Open dialog
        setFilterDialogOpen(true);
      };
      
    
    const handleCloseFilterDialog = () => {
        // 1. Restore severity filters
        const restoredSeverityFilters = {
          all: appliedSeverities.length === 4,
          5: appliedSeverities.includes(5),
          4: appliedSeverities.includes(4),
          3: appliedSeverities.includes(3),
          2: appliedSeverities.includes(2),
        };
        setSeverityFilters(restoredSeverityFilters);
      
        // 2. Recalculate documentation counts based on restored severities
        const updatedDocCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
        allInteractionResults.forEach((result) => {
          if (appliedSeverities.includes(result.severityLevel)) {
            updatedDocCounts[result.documentationLevel] += 1;
          }
        });
        setDocumentationCounts(updatedDocCounts);
      
        // 3. Restore documentation filters & disable ones with 0 count
        const restoredDocFilters = {
          1: appliedDocs.includes(1) && updatedDocCounts[1] > 0,
          2: appliedDocs.includes(2) && updatedDocCounts[2] > 0,
          3: appliedDocs.includes(3) && updatedDocCounts[3] > 0,
          4: appliedDocs.includes(4) && updatedDocCounts[4] > 0,
        };
        restoredDocFilters.all =
          [1, 2, 3, 4].every((lvl) => restoredDocFilters[lvl]);
      
        setDocumentationFilters(restoredDocFilters);
      
        // 4. Close the dialog
        setFilterDialogOpen(false);
      };
      
      
    
    const handleSeverityChange = (key) => {
        let updatedFilters;

        if (key === 'all') {
            const allChecked = !severityFilters.all;
            updatedFilters = {
            all: allChecked,
            5: allChecked && severityCounts[5] > 0,
            4: allChecked && severityCounts[4] > 0,
            3: allChecked && severityCounts[3] > 0,
            2: allChecked && severityCounts[2] > 0,
            };
        } else {
            updatedFilters = {
            ...severityFilters,
            [key]: !severityFilters[key],
            };
            updatedFilters.all = [5, 4, 3, 2].every((level) => updatedFilters[level]);
        }

        setSeverityFilters(updatedFilters);

        // 🔁 Now update documentation level counts based on selected severities
        const selectedSeverities = [5, 4, 3, 2].filter((level) => updatedFilters[level]);

        const newDocCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
        allInteractionResults.forEach((item) => {
            if (selectedSeverities.includes(item.severityLevel)) {
            newDocCounts[item.documentationLevel] += 1;
            }
        });
        setDocumentationCounts(newDocCounts);

        // Rebuild documentationFilters: check + disable logic
        const newDocFilters = {};
        const validDocs = [];

        [1, 2, 3, 4].forEach((docLevel) => {
            const hasResults = newDocCounts[docLevel] > 0;
            newDocFilters[docLevel] = hasResults;
            if (hasResults) validDocs.push(docLevel);
        });

        newDocFilters.all = validDocs.length === 4;
        setDocumentationFilters(newDocFilters);
    };


    const handleDocumentationChange = (key) => {
        let updatedFilters;
      
        if (key === 'all') {
          const newState = {
            all: !documentationFilters.all,
            4: !documentationFilters.all && documentationCounts[4] > 0,
            3: !documentationFilters.all && documentationCounts[3] > 0,
            2: !documentationFilters.all && documentationCounts[2] > 0,
            1: !documentationFilters.all && documentationCounts[1] > 0,
          };
          updatedFilters = newState;
        } else {
          updatedFilters = {
            ...documentationFilters,
            [key]: !documentationFilters[key],
          };
          updatedFilters.all = [4, 3, 2, 1].every((lvl) => updatedFilters[lvl]);
        }
      
        setDocumentationFilters(updatedFilters);
      
        // 🧠 Recalculate doc counts from selected severities
        const selectedSeverities = Object.entries(severityFilters)
          .filter(([k, v]) => k !== 'all' && v)
          .map(([k]) => Number(k));
      
        const updatedDocCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
      
        allInteractionResults.forEach((result) => {
          if (selectedSeverities.includes(result.severityLevel)) {
            updatedDocCounts[result.documentationLevel] += 1;
          }
        });
      
        setDocumentationCounts(updatedDocCounts);
      
        // 🧠 Uncheck + disable docs with 0 count
        const updatedDocFiltersWithDisables = { ...updatedFilters };
        [1, 2, 3, 4].forEach((level) => {
          if (updatedDocCounts[level] === 0) {
            updatedDocFiltersWithDisables[level] = false;
          }
        });
      
        // Update the filters
        setDocumentationFilters(updatedDocFiltersWithDisables);
      };
      
      
    const [searchFilteredResults, setSearchFilteredResults] = useState([]); 
    const [filteredResults, setFilteredResults] = useState([]); 
    const [isFiltered, setIsFiltered] = useState(false);
    // Declare selected severities and documentation levels globally using useState
    const [selectedSeverities, setSelectedSeverities] = useState([]);
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [totalFilteredCount, setTotalFilteredCount] = useState(0);
    const finalCount = isFiltered? totalFilteredCount : totalCount;
    const [paginatedResults, setPaginatedResults] = useState([]);
    const [appliedSeverities, setAppliedSeverities] = useState([]);
    const [appliedDocs, setAppliedDocs] = useState([]);

    const handleFilterChange = async () => {
        setRowsPerPage(5);
        document.getElementById("loaderPage").style.display = "flex";
        document.getElementById("loaderPage").style.zIndex = "1400";
    
        const selectedSeverities = Object.entries(severityFilters)
            .filter(([key, value]) => key !== 'all' && value)
            .map(([key]) => Number(key));
    
        const selectedDocs = Object.entries(documentationFilters)
            .filter(([key, value]) => key !== 'all' && value)
            .map(([key]) => Number(key));
    
        // 🔁 Recalculate what the "original valid filters" would be from allInteractionResults
        const severityCounts = { 5: 0, 4: 0, 3: 0, 2: 0 };
        const docCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
    
        allInteractionResults.forEach(result => {
            severityCounts[result.severityLevel] += 1;
        });
    
        const originalValidSeverities = Object.keys(severityCounts)
            .filter(key => severityCounts[key] > 0)
            .map(Number);
    
        allInteractionResults.forEach(result => {
            if (originalValidSeverities.includes(result.severityLevel)) {
                docCounts[result.documentationLevel] += 1;
            }
        });
    
        const originalValidDocs = Object.keys(docCounts)
            .filter(key => docCounts[key] > 0)
            .map(Number);
    
        // Check if current checked filters match the original valid ones
        const isSameAsOriginal =
            selectedSeverities.slice().sort().toString() === originalValidSeverities.slice().sort().toString() &&
            selectedDocs.slice().sort().toString() === originalValidDocs.slice().sort().toString();
    
        if (isSameAsOriginal) {
            // Same as reset — no filtering needed, just fetch the original data (5 rows, page 1)
            handleResetFilters();
            return;
        }
    
        // 🔽 Otherwise, do regular filtering
        setSelectedSeverities(selectedSeverities);
        setSelectedDocs(selectedDocs);
        setAppliedSeverities(selectedSeverities); 
        setAppliedDocs(selectedDocs);  
    
        const allResults = await getInteractionVP(lastValidInputs, 1, totalCount);
        const interactions = allResults.data?.drugInteractions || [];
    
        const filtered = interactions.filter(result =>
            selectedSeverities.includes(result.severityLevel) &&
            selectedDocs.includes(result.documentationLevel)
        );
    
        setSearchFilteredResults(filtered);
    
        const firstPaginatedResults = filtered.slice(0, 5);
        setPaginatedResults(firstPaginatedResults);
        setFilteredResults(firstPaginatedResults); 
        setIsFiltered(true);
        setTotalFilteredCount(filtered.length);
        setCurrentPage(1);
    
        setInputs(lastValidInputs);
        setSelectedMedicines(lastValidInputs); 
    
        if (AllergyResults && AllergyResults.count > 0) {  
            const formattedAllergies = lastValidAllergyInputs.map(allergy => ({
                id: allergy.allergenId,
                label: allergy.allergenName,
                type: allergy.allergenType
            }));
            setInputAllergy(lastValidAllergyInputs);
            setSelectedAllergy(formattedAllergies);
        }
    
        document.getElementById("loaderPage").style.display = "none";
        handleCloseFilterDialog();
    };
    
    
    
    const handleResetFilters = async () => {
        document.getElementById("loaderPage").style.display = "flex";
        document.getElementById("loaderPage").style.zIndex = "1400";
        // Clear filtered state and results
        setFilteredResults([]);
        setSearchFilteredResults([]);
        setIsFiltered(false);
        setCurrentPage(1);
        setRowsPerPage(5); // Ensure the rows per page reset to 5
    
        // Reset to full results
        const allResults = allInteractionResults;
    
        // Step 1: Count severities
        const severityCounts = { 5: 0, 4: 0, 3: 0, 2: 0 };
        allResults.forEach(result => {
            severityCounts[result.severityLevel] += 1;
        });
    
        // Step 2: Determine which severity filters are actually available
        const initialSeverities = Object.keys(severityCounts)
          .filter(key => severityCounts[key] > 0)
          .map(key => Number(key));
    
        const newSeverityFilters = {
            5: severityCounts[5] > 0,
            4: severityCounts[4] > 0,
            3: severityCounts[3] > 0,
            2: severityCounts[2] > 0,
        };
        newSeverityFilters.all = initialSeverities.length === 4;
        setSeverityFilters(newSeverityFilters);
        setAppliedSeverities(initialSeverities);
        setSelectedSeverities(initialSeverities);
    
        // Step 3: Count documentation levels based on available severities
        const docCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
        allResults.forEach(result => {
            if (initialSeverities.includes(result.severityLevel)) {
                docCounts[result.documentationLevel] += 1;
            }
        });
    
        const initialDocs = Object.keys(docCounts)
          .filter(key => docCounts[key] > 0)
          .map(key => Number(key));
    
        const newDocFilters = {
            1: docCounts[1] > 0,
            2: docCounts[2] > 0,
            3: docCounts[3] > 0,
            4: docCounts[4] > 0,
        };
        newDocFilters.all = initialDocs.length === 4;
        setDocumentationFilters(newDocFilters);
        setAppliedDocs(initialDocs);
        setSelectedDocs(initialDocs);
        setDocumentationCounts(docCounts);
    
        // Reset to unfiltered data and show first 5 rows
        const firstPage = allResults.slice(0, 5);
        setPaginatedResults(firstPage);
        setFilteredResults(firstPage);
    
        // Always fetch results based on the last valid search inputs (ignoring recent removals)
        const searchInputs = lastValidInputs; // Get stored medicine inputs
        const searchAllergyInputs = lastValidAllergyInputs; // Get stored allergy inputs
        setInputs(searchInputs);
        setSelectedMedicines(searchInputs);
        
        // Make sure to fetch the first 5 results
        const results = await getInteractionVP(searchInputs, 1, 5);
        setInteractionResults(results);
        // Restore ALL original inputs in the autocomplete field (before any removals)
        if (AllergyResults && AllergyResults.count > 0) {  
            console.log(" Restoring Allergies from Previous Inputs:", searchAllergyInputs);

            const formattedAllergies = searchAllergyInputs.map(allergy => ({
                id: allergy.allergenId,
                label: allergy.allergenName,
                type: allergy.allergenType
            }));

            console.log(" Converted Allergies for Autocomplete:", formattedAllergies);

            setInputAllergy(searchAllergyInputs);
            setSelectedAllergy(formattedAllergies);
        } else {
            console.log(" Allergy results are empty, skipping restoration.");
        }
        document.getElementById("loaderPage").style.display = "none";
        setFilterDialogOpen(false);
        
    };

    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const handleOpenSearchDialog = () => {
    setIsSearchModalOpen(true);
    };
    const handleCloseSearchDialog = () => {
        // Always fetch results based on the last valid search inputs (ignoring recent removals)
        const searchInputs = lastValidInputs; // Get stored medicine inputs
        const searchAllergyInputs = lastValidAllergyInputs; // Get stored allergy inputs
        setInputs(searchInputs);
        setSelectedMedicines(searchInputs);
        // Restore ALL original inputs in the autocomplete field (before any removals)
        if (AllergyResults && AllergyResults.count > 0) {  
            console.log(" Restoring Allergies from Previous Inputs:", searchAllergyInputs);

            const formattedAllergies = searchAllergyInputs.map(allergy => ({
                id: allergy.allergenId,
                label: allergy.allergenName,
                type: allergy.allergenType
            }));

            console.log(" Converted Allergies for Autocomplete:", formattedAllergies);

            setInputAllergy(searchAllergyInputs);
            setSelectedAllergy(formattedAllergies);
        } else {
            console.log(" Allergy results are empty, skipping restoration.");
        }
        setIsSearchModalOpen(false);
      };
      const handleSubmit = (e) => {
        e.preventDefault(); // prevent form submission if it's inside a <form>
        CheckInteractionHandle(); // will use current inputs from state
    };
    const [autoCompleteOpen, setAutoCompleteOpen] = useState(false);
    const [hasUserTyped, setHasUserTyped] = useState(false);

    const SearchPanel = useCallback(() => (
            <div id="queryFilter" className={isFloating ? "floating" : ""} style={{
                top: isFloating ? '68px' : '60px',
                transition: 'top 0.2s ease',
              }}>
                <div className="w-100 mb-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h5 className="my-0" style= {{color: theme.primaryText, fontWeight: "Bold"}}>Search Filters</h5>
                        {!isLgScreen && interactionResults.success === true ? (
                        <IconButton onClick={handleCloseSearchDialog}>
                            <IconX />
                        </IconButton>
                        ) : (
                        <Button
                            disabled={inputs.length === 0}
                            variant="text"
                            color="error"
                            onClick={OnClickClear}
                            startIcon={<IconTrash />}
                            sx={{ textTransform: "none" }}
                        >
                            Clear All
                        </Button>
                        )}
                    </div>
                <hr/>
                <FormControl sx={{ mb: 2 }} fullWidth>
                    <FormLabel sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Prescribed Medicines
                    </FormLabel>
                    <Autocomplete
                        open={autoCompleteOpen}
                        onOpen={() => {
                            // Only allow opening if user has started typing
                            if (hasUserTyped && query?.length >= 1) {
                                setAutoCompleteOpen(true);
                            }
                        }}
                        onClose={() => setAutoCompleteOpen(false)}
                        autoHighlight
                        multiple
                        limitTags={2}
                        id="PrescribedMedicines"
                        options={PrescribedMedicines}
                        filterOptions={(options) => {
                            if (!query || query.length < 3) return [];

                                return options
                                    .filter((option) => !selectedMedicines.some((selected) => selected.id === option.id))
                                    .filter((option) =>
                                        option.label?.toLowerCase().includes(query.toLowerCase())
                                    ); // null-safe check for label
                            }}
                        loading={isLoading}
                        loadingText={
                            query?.length < 3 ? (
                              "Type at least three (3) characters for suggestions"
                            ) : (
                              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <CircularProgress size={16} />
                                Loading...
                              </span>
                            )
                          }
                        noOptionsText={!isLoading || query?.length >= 3 ? "No options found" : "Type at least three (3) characters for suggestions"}
                        disablePortal
                        defaultValue={interId != null ? [{
                            id: interId + '|' + interType,
                            label: interName
                        }] : []} 
                        value={selectedMedicines} // Ensures the chips are properly restored
                        onChange={(event, newValue) => {
                            setSelectedMedicines(newValue);
                            setInputs(newValue);
                            handleSearchNavigate(newValue);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                            setQuery(newInputValue);
                            setIsLoading(true);
                             // Track whether this was triggered by user typing
                            if (reason === "input") {
                                setHasUserTyped(true);
                                setAutoCompleteOpen(true);
                            }

                            // Optional: close popup if it's too short
                            if (newInputValue.length < 1) {
                                setAutoCompleteOpen(false);
                            }
                        }}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip key={option.id} label={option.label} {...getTagProps({ index })} />
                            ))
                        }
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                placeholder={inputs?.length > 0 ? "Add more..." : "Enter Prescribed Medicines"}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <>
                                            <InputAdornment position="start">
                                                <IconSearch size={20} />
                                            </InputAdornment>
                                            {params.InputProps.startAdornment}
                                        </>
                                    ),
                                }}
                            />
                        }
                    />
                </FormControl>
                <FormControl sx={{ mb: 2 }} fullWidth>
                    <FormLabel sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Known Allergies
                    </FormLabel>
                    <Autocomplete
                        autoHighlight
                        multiple
                        limitTags={2}
                        id="KnownAllergies"
                        options={PrescribedMedicines}
                        filterOptions={(options) => {
                            if (!allergyQuery || allergyQuery.length < 3) return []; // No options before typing at least 3 chars
                    
                            return options
                                .filter((option) => !selectedAllergy.some((selected) => selected.id === option.id)) // Exclude selected items
                                .filter((option) => option.label.toLowerCase().includes(allergyQuery.toLowerCase()));
                        }}
                        loading={isLoading}
                        loadingText={
                            allergyQuery?.length < 3 ? (
                              "Type at least three (3) characters for suggestions"
                            ) : (
                              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <CircularProgress size={16} />
                                Loading...
                              </span>
                            )
                          }
                        noOptionsText={!isLoading && allergyQuery?.length >= 3 ? "No options found" : "Type at least three (3) characters for suggestions"}
                        open={allergyQuery?.length > 0} 
                        disablePortal
                        value={selectedAllergy}
                        onChange={(event, newValue) => {
                            console.log("🛠 Raw New Value:", newValue);
                        
                            setSelectedAllergy(newValue);
                            handleSearchChangeAllergies(newValue);
                        
                            if (newValue.length > 0) {
                                const formattedAllergy = newValue.map(val => ({
                                    allergenId: val.id || "MISSING_ID", 
                                    allergenType: val.type || "MISSING_TYPE",
                                    allergenName: val.label || "MISSING_NAME"
                                }));
                        
                                console.log(" Formatted Allergy Data:", formattedAllergy);
                                setInputAllergy(formattedAllergy);
                            } else {
                                console.log("🚨 No allergies selected. Resetting inputAllergy.");
                                setInputAllergy([]);
                            }
                        }}
                        
                        onInputChange={(event, newInputValue) => {
                            setAllergyQuery(newInputValue);
                            setIsLoading(true);
                        }}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip key={option.id} label={option.label} {...getTagProps({ index })} />
                            ))
                        }
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                placeholder={inputAllergy?.length > 0 ? "Add more..." : "Enter Known Allergies"}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <>
                                            <InputAdornment position="start">
                                                <IconSearch size={20} />
                                            </InputAdornment>
                                            {params.InputProps.startAdornment}
                                        </>
                                    ),
                                }}
                            />
                        }
                    />
                </FormControl>
                </div>
                <div style={{ display: "flex", gap: "8px", width: "100%", flexWrap: "wrap", marginTop: "auto" }}>
                    {!isLgScreen && interactionResults.success === true && (
                        <Button
                        disabled={inputs.length === 0}
                        variant="text"
                        color="error"
                        onClick={OnClickClear}
                        startIcon={<IconTrash />}
                        sx={{
                            flex: 1,
                            padding: "16px 32px",
                            borderRadius: "16px",
                            minWidth: 0,
                            whiteSpace: "nowrap"
                        }}
                        >
                        Clear
                        </Button>
                    )}

                    <Button
                        disabled={inputs.length === 0}
                        variant="contained"
                        type="submit"
                        onClick={handleSubmit}
                        fullWidth={!isLgScreen}
                        sx={{
                        flex: 1,
                        borderRadius: "16px",
                        minWidth: 0,
                        padding: "16px 32px",
                        backgroundColor: theme.primary,
                        color:"#fff",
                        whiteSpace: "nowrap"
                        }}
                        startIcon={<IconZoomCheckFilled />}
                    >
                        {!isLgScreen && interactionResults.success === true
                        ? "Check"
                        : "Check Interactions"}
                    </Button>
                </div>
            </div>
    ), [
        inputs,
        setInputs,
        selectedMedicines,
        setSelectedMedicines,
        query,
        setQuery,
        allergyQuery,
        setAllergyQuery,
        selectedAllergy,
        setSelectedAllergy,
        inputAllergy,
        setInputAllergy,
        isLoading,
        setIsLoading,
        interId,
        interType,
        interName,
        PrescribedMedicines,
        OnClickClear,
        handleSearchNavigate,
        handleSearchChangeAllergies,
        CheckInteractionHandle,
        isFloating
      ]);
      const muiTheme = useTheme();

      const transitionDuration = {
        enter: muiTheme.transitions.duration.enteringScreen,
        exit: muiTheme.transitions.duration.leavingScreen,
      };
      const [disclaimerOpen, setDisclaimerOpen] = useState(false);
      const [activeDisclaimer, setActiveDisclaimer] = useState('');

      const renderDisclaimerModal = () => (
        <Dialog open={disclaimerOpen} onClose={() => setDisclaimerOpen(false)} fullWidth maxWidth="sm"  PaperProps={{style: { borderRadius: '16px'}}}>

          <DialogTitle style={{color: "red", fontWeight: "bold"}}>Disclaimer</DialogTitle>
          <DialogContent dividers>
            <div style={{ fontSize: '12px' }}>
                {activeDisclaimer && parse(`<p>${activeDisclaimer?.split("<br />").join("</p><p>")}</p>`)}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDisclaimerOpen(false)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      );
      
      
    return (<>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <InteractionModal
            show={InteractionShow}
            onHide={() => setInteractionShow(false)}
        />
        <AllergyModal
            show={AllergymodalShow}
            onHide={() => setAllergyModalShow(false)}

        />
        <Banner />
        <Sidebar activeButton={activeButton} />
        <div id="DrugAllergyInteractions">
            <Container fluid id="main">
                <Row id="content">
                    <Col>
                        <div id="contentCaption">
                            <h2>
                            Drug & Allergy Interactions
                            </h2>
                            {isLgScreen && (
                                <span>Identify potentially harmful combinations of medications or medications that may be unsuitable due to an allergy or health condition.</span>
                            )}
                        </div>
                        <Row className={ isLgScreen ? 'my-3 d-flex flex-row' : ''}  style={{
                                height: !isLgScreen && interactionResults.success !== true ? "100%" : ""
                              }}>
                        <Col id="queryContainer" md={12} lg={4} 
                        style={{ 
                            height: !isLgScreen && interactionResults.success !== true ? "" : "100%",
                            paddingTop: !isLgScreen && interactionResults.success !== true ? "32px" : ""}}>
                            {/* Sentinel for triggering float */}
                            <div ref={sentinelRef} style={{ height: '1px' }}></div>
                            {isLgScreen ? (
                                //  Always show SearchPanel on large screens
                                SearchPanel()
                            ) : interactionResults.success === true ? (
                                //  On small screens *after* results, show button + dialog
                                <>
                               
                                
                                <Button
                                    variant="contained"
                                    sx={{padding: "16px 32px",
                                        borderRadius: "16px",
                                        backgroundColor: "#0262AB",
                                        marginBottom: "16px"}}
                                    fullWidth
                                    startIcon={<IconSearch/>}
                                    onClick={handleOpenSearchDialog}
                                >
                                   Open Search Filters
                                </Button>
                                <Dialog
                                    open={isSearchModalOpen}
                                    onClose={handleCloseSearchDialog}
                                    id="searchPanelModal"
                                >
                                    <DialogContent>
                                    {SearchPanel()}
                                    </DialogContent>
                                </Dialog>
                                </>
                            ) : (
                                //  On small screens, only show SearchPanel *before* results
                                SearchPanel()
                            )}
                        </Col>

                            
                            <Col id="resultsContainer" lg={8} md={12} 
                            style={{
                                display: !isLgScreen && interactionResults.success !== true ? "none" : "block"
                              }}>
                              
                                {interactionResults.success === true ? (
                                    <Box sx={{ width: "100%" }}>
                                        {/* Tabs Navigation */}
                                        <Box 
                                        className={isTabsFloating ? "tabsFloating" : ""}
                                        style={{
                                            width: "100%",
                                            
                                            position: isLgScreen ? "relative" : "",
                                            zIndex: 10,
                                            borderBottom: "none",
                                            borderColor: theme.primary,
                                            backgroundColor: isTabsFloating ? "white" : "",
                                            paddingBottom: isTabsFloating && (noInteractionDisclaimer || noAllergyDisclaimer) ? 0 : ""
                                        }}>
                                            <Tabs 
                                                value={tabValue} 
                                                onChange={handleTabChange} 
                                                aria-label="results tabs"
                                                variant={isLgScreen ? undefined :"fullWidth"}
                                                sx={{
                                                    "& .MuiTabs-flexContainer": { position: "relative" },
                                                    "& .MuiTab-root": {
                                                        position: "relative",
                                                        zIndex: 1,
                                                        paddingBottom: "8px", // Ensure proper spacing from the border
                                                    },
                                                    "& .MuiTabs-indicator": {
                                                        display: "none", // Hides the default indicator
                                                    },
                                                    "&::after": {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "1px",
                                                        backgroundColor: theme.primary,
                                                        zIndex: 0,
                                                        display: isLgScreen ? "block" : "none"
                                                    },
                                                }}
                                            >
                                                <Tab 
                                                    label="Drug Interactions" 
                                                    icon={
                                                        <Chip
                                                        label={finalCount}
                                                        size="small"
                                                        className="totalChip"
                                                        color={
                                                            finalCount === 0
                                                            ? "default" // If totalCount is 0, set color to default
                                                            : isFiltered
                                                            ? "primary" // If filtered, set color to primary
                                                            : "error" // If not filtered, use the red color
                                                        }/>

                                                    }
                                                    iconPosition="end"
                                                    sx={{
                                                        backgroundColor: "#eaf5ff",
                                                        "&.Mui-selected": { backgroundColor: "white" },
                                                        "&.Mui-selected::after": {
                                                            content: '""',
                                                            position: "absolute",
                                                            bottom: "-1px",
                                                            left: 0,
                                                            width: "100%",
                                                            height: "1px",
                                                            backgroundColor: "white",
                                                            zIndex: 1,
                                                        },
                                                    }}
                                                />
                                                <Tab 
                                                    label="Allergy Check" 
                                                    disabled={!isAllergyTabEnabled} 
                                                    icon={
                                                        isAllergyTabEnabled ? (
                                                            <Chip 
                                                                label={totalCountAllergy} 
                                                                size="small" 
                                                                className="totalChip"
                                                                color={totalCountAllergy > 0 ? "error" : "default" } 
                                                            />
                                                        ) : null
                                                    }
                                                    iconPosition="end"
                                                    sx={{
                                                        "&.MuiTab-root": {
                                                          backgroundColor: !isAllergyTabEnabled ? "#ffffff" : "#eaf5ff", // Apply only when not enabled
                                                        },
                                                        "&.Mui-selected::after": {
                                                          content: '""',
                                                          position: "absolute",
                                                          bottom: "-1px",
                                                          left: 0,
                                                          width: "100%",
                                                          height: "1px",
                                                          backgroundColor: "white",
                                                          zIndex: 1,
                                                        },
                                                      }}
                                                      
                                                />
                                            </Tabs>
                                        </Box>


                                        {/* Tab Panels */}
                                        {tabValue === 0 && (
                                            <Box pt={isLgScreen ? 2:0} 
                                              style={{
                                                paddingTop:
                                                isTabsFloating && !isLgScreen
                                                ? noInteractionDisclaimer
                                                    ? "40px"
                                                    : "72px"
                                                : undefined
                                              }}>
                                                {isLgScreen && (
                                                  <h4 className="align-self-start">Drug Interaction Results</h4>
                                                )}
                                                   
                                                {noInteractionDisclaimer ? (
                                                    <div className="noResultAlert mt-3" style={{ display: 'flex', flexDirection: 'column'}}>
                                                    {!isLgScreen ? (
                                                           <>
                                                           <Row className='d-flex align-items-center' style={{ flexWrap: 'nowrap' }}>
                                                               <Col md={2}  style={{width:"fit-content"}}>
                                                                   <IconInfoTriangleFilled size={32} style={{ color: '#0262AB' }} />
                                                               </Col>
                                                               <Col md={10} style={{ paddingRight: "8px", flex: 1 }}>
                                                                   <span style={{ fontSize: "16px", fontWeight: "bold", }}>
                                                                   No drug-drug interaction records found
                                                                   </span>
                                                               </Col>
                                                           </Row>
       
                                                           <Col md={12} style={{fontSize: 12}}>
                                                                <p style={{ margin: 0, marginBottom: 12 }}>
                                                                    {parse(noInteractionDisclaimer.split('<br />')[0])}
                                                                </p>
                                                                <p style={{ margin: 0 }}>
                                                                    {parse(noInteractionDisclaimer.split('<br />')[1])}
                                                                </p>
                                                           </Col>
                                                           </>
                                                       ) : (
                                                           <>
                                                               <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                        {/* Column 1: Icon */}
                                                        <IconInfoTriangleFilled size={92} color="#0061AA" style={{ marginRight: '16px', flexShrink: 0 }} />

                                                        {/* Column 2: Title and First Paragraph */}
                                                        <div style={{ flex: 1 }}>
                                                            {/* Title */}
                                                            <h4 style={{ margin: 0, marginBottom: 8, fontWeight: "bold" }}>No drug-drug interaction records found</h4>
                                                            {/* First Paragraph of Disclaimer */}
                                                            <p style={{ margin: 0 }}>
                                                                {parse(noInteractionDisclaimer.split('<br />')[0])}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Second Paragraph of Disclaimer (after <br />) */}
                                                    <div style={{ marginTop: 0 }}>
                                                        <p style={{ margin: 0 }}>
                                                            {parse(noInteractionDisclaimer.split('<br />')[1])}
                                                        </p>
                                                    </div>
                                                           </>
                                                       )}
                                               
                                                    
                                                </div>
                                                ) : (
                                                    <>
                                                    <div className={isTabsFloating ? "rowOptionsFloating " : "d-flex justify-content-between align-items-center w-100"}>
                                                        <div className='custom-pagination'  style={{ flexGrow: 1, marginRight: 16 }}>
                                                            <TablePagination
                                                            style={{
                                                                fontSize: { xs: "12px", lg: "inherit" } // 12px on small screens, default on large
                                                              }}
                                                                rowsPerPageOptions={
                                                                    finalCount <= 5
                                                                        ? [] // Hide rows per page when finalCount <= 5
                                                                        : finalCount <= 10
                                                                        ? [5, { label: "All", value: -1 }] // Show 5 and "All" when finalCount <= 10
                                                                        : finalCount <= 25
                                                                        ? [5, 10, { label: "All", value: -1 }] // Show 5, 10, and "All" when finalCount <= 25
                                                                        : [5, 10, 25, { label: "All", value: -1 }] // Show all options when finalCount > 25
                                                                }
                                                                component="div"
                                                                count={finalCount}
                                                                rowsPerPage={rowsPerPage}
                                                                page={currentPage - 1}
                                                                onPageChange={(event, newPage) => CheckPageInteractionHandleIndex(event, newPage + 1)}
                                                                onRowsPerPageChange={(event) => {
                                                                    const newRowsPerPage = parseInt(event.target.value, 10);
                                                                    setRowsPerPage(newRowsPerPage);
                                                                    setCurrentPage(1);
                                                                    CheckPageInteractionHandleIndex(null, 1, newRowsPerPage);
                                                                }}
                                                                ActionsComponent={CustomPaginationActions}
                                                                labelRowsPerPage={isLgScreen ? "Rows per page" : "Rows"}
                                                                labelDisplayedRows={({ from, to, count }) => {
                                                                    // If results are filtered
                                                                    if (isFiltered) {
                                                                        if (count === 1) {
                                                                          return (
                                                                            <>
                                                                              {!isLgScreen ? null : "Showing "} 
                                                                              1 <strong style={{ color: "#0262AB" }}>filtered </strong>result
                                                                            </>
                                                                          );
                                                                        }
                                                                      
                                                                        if (count <= rowsPerPage) {
                                                                          return (
                                                                            <>
                                                                              {!isLgScreen ? null : "Showing "} 
                                                                              {count} <strong style={{ color: "#0262AB" }}>filtered </strong>results
                                                                            </>
                                                                          );
                                                                        }
                                                                      
                                                                        return (
                                                                          <>
                                                                            {!isLgScreen ? `${from}-${to} of ` : `Showing ${from}-${to} of `} 
                                                                            {count} <strong style={{ color: "#0262AB" }}>filtered </strong>results
                                                                          </>
                                                                        );
                                                                      }
                                                                      
                                                                // Non-filtered results
                                                                if (rowsPerPage === -1 || (count <= 5 && count > 1)) {
                                                                    return `${!isLgScreen ? "" : "Showing "}${count} results`;
                                                                }
                                                                
                                                                if (count === 1) {
                                                                    return `${!isLgScreen ? "" : "Showing "}1 result`;
                                                                }
                                                                
                                                                return `${!isLgScreen ? `${from}-${to} of ` : `Showing ${from}-${to} of `}${count} results`;
  
                                                                }}
                                                                
                                                                
                                                            />
                                                        </div>
                                                        <Button
                                                            className={`${noInteractionDisclaimer ? 'd-none' : 'd-flex'}`}
                                                            variant={isFiltered ? 'contained' : 'outlined'}
                                                            size="small"
                                                            startIcon={
                                                                <Badge color="secondary" variant="dot" invisible={!isFiltered}>
                                                                <IconFilterFilled size={isLgScreen ? 16 : 12} />
                                                                </Badge>
                                                            }
                                                            sx={{
                                                                borderRadius: "8px",
                                                                textTransform: "none",
                                                                fontSize: isLgScreen ? undefined : "12px", // just this
                                                            }}
                                                            onClick={handleOpenFilterDialog}
                                                            >
                                                            Filter
                                                        </Button>

                                                    </div>
                                                        
                                                    {(isFiltered ? filteredResults : interactionResults.data?.drugInteractions)?.length > 0 && (
                                                            isLgScreen ? (
                                                                <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                                <Table aria-label="simple table">
                                                                    <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Medicine</TableCell>
                                                                        <TableCell align="center">Route</TableCell>
                                                                        <TableCell>Interacting Medicine</TableCell>
                                                                        <TableCell align="center">Route</TableCell>
                                                                        <TableCell align="center">Severity</TableCell>
                                                                        <TableCell align="center">Documentation level</TableCell>
                                                                        <TableCell></TableCell>
                                                                    </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                    {(isFiltered ? filteredResults : interactionResults.data?.drugInteractions).map((val, index) => (
                                                                        <TableRow
                                                                        key={index}
                                                                        onClick={() =>
                                                                            handleTxtValueInteraction(
                                                                            val.severityLevel,
                                                                            val.severityLevelName,
                                                                            val.documentationLevel,
                                                                            val.documentationLevelName,
                                                                            val.molecule,
                                                                            val.interactingMolecule,
                                                                            val.observation,
                                                                            val.className1,
                                                                            val.classDescription1,
                                                                            val.className2,
                                                                            val.classDescription2,
                                                                            val.precaution,
                                                                            val.drugInteractionDetails,
                                                                            val.references
                                                                            )
                                                                        }
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            "&:hover": { backgroundColor: "#f5f5f5" },
                                                                        }}
                                                                        >
                                                                        <TableCell component="th" scope="row" className="molecule">
                                                                            {parse(val.molecule)}
                                                                        </TableCell>
                                                                        <TableCell align="center">{val.route1}</TableCell>
                                                                        <TableCell className="molecule">{val.interactingMolecule}</TableCell>
                                                                        <TableCell align="center">{val.route2}</TableCell>
                                                                        <TableCell align="center">
                                                                            <div className="table-chip-container">
                                                                            <Chip label={val.severityLevelName} color={getSeverityColor(val.severityLevel)} />
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <Chip
                                                                            label={val.documentationLevelName}
                                                                            color={getDocLevelColor(val.documentationLevel)}
                                                                            variant="outlined"
                                                                            sx={{ borderWidth: "3px", borderStyle: "solid" }}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell id="open">
                                                                            <IconExternalLink color="#0262AB" size={16} />
                                                                        </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                    </TableBody>
                                                                </Table>
                                                                </TableContainer>
                                                            ) : (
                                                                <>
                                                                 <Row className='mb-1 py-2'style={{ fontSize: 10, fontWeight: "bold", alignItems: "center", backgroundColor: "#dee2e6",  marginTop: isTabsFloating ? "12px" : "0.5rem"}}>
                                                                    <Col xs={8} md={8}>
                                                                        <span>Interaction</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} style={{textAlign: "center"}}>
                                                                    <span> Severity/<br/>Documentation </span>
                                                                    </Col>
                                                                  </Row>
                                                                {(isFiltered ? filteredResults : interactionResults.data?.drugInteractions).map((val, index) => (
                                                                  
                                                                <Row className='mobileRows'style={{ fontSize: 12 }}  key={index}
                                                                onClick={() =>
                                                                    handleTxtValueInteraction(
                                                                    val.severityLevel,
                                                                    val.severityLevelName,
                                                                    val.documentationLevel,
                                                                    val.documentationLevelName,
                                                                    val.molecule,
                                                                    val.interactingMolecule,
                                                                    val.observation,
                                                                    val.className1,
                                                                    val.classDescription1,
                                                                    val.className2,
                                                                    val.classDescription2,
                                                                    val.precaution,
                                                                    val.drugInteractionDetails,
                                                                    val.references,
                                                                    val.route1,
                                                                    val.route2
                                                                    
                                                                    )
                                                                }>
                                                                 <Col xs={8} md={8} >
                                                                    <span style={{color: "#0262AB"}}>
                                                                        {val.molecule} <em style={{color: "#727272"}}>({val.route1})</em>
                                                                        <span className="text-danger mx-2">⭤</span>
                                                                        {val.interactingMolecule} <em style={{color: "#727272"}}>({val.route2})</em>
                                                                    </span>
                                                                    
                                                                </Col>

                                                                  <Col xs={4} md={4}>
                                                                    <List style={{padding: 0}}>
                                                                      <ListItem style={{padding: 0, paddingBottom: "4px", justifyContent: "end", width: "100%"}}>
                                                                        <ListItemIcon style={{  width: "100%" }}>
                                                                          <Chip
                                                                            size="small"
                                                                            label={val.severityLevelName}
                                                                            color={getSeverityColor(val.severityLevel)}
                                                                            style={{
                                                                              fontWeight: "bold",
                                                                              textAlign: "center",
                                                                              width: "100%"
                                                                            }}
                                                                          />
                                                                        </ListItemIcon>
                                                                      </ListItem>
                                                                      <ListItem style={{padding: 0, justifyContent: "end",  width: "100%"}}>
                                                                        <ListItemIcon style={{  width: "100%" }}>
                                                                          <Chip
                                                                            size="small"
                                                                            label={val.documentationLevelName}
                                                                            color={getDocLevelColor(val.documentationLevel)}
                                                                            variant="outlined"
                                                                            style={{
                                                                              fontWeight: "bold",
                                                                              textAlign: "center",
                                                                              width: "100%",
                                                                            }}
                                                                          />
                                                                        </ListItemIcon>
                                                                      </ListItem>
                                                                    </List>
                                                                  </Col>
                                                                  <Col xs={8} md={8}>
                                                                  <ul style={{ listStyleType: "none", paddingLeft: 0, fontSize: 10 }}>
                                                                        {val.precaution.split('<BR>').map((item, idx) => (
                                                                        <li key={idx}>{item}</li>
                                                                        ))}
                                                                    </ul>
                                                                  
                                                                  </Col>
                                                                  <Col xs={4} md={4} style={{display: "flex", alignItems:"center", justifyContent: "end"}}>
                                                                     <IconArrowRight color="#0262AB" size={16} />
                                                                 
                                                                  </Col>
                                                                  <hr className='m-0'/>
                                                                </Row>
                                                                
                                                                ))}
                                                                
                                                              </>
                                                            )
                                                        )}

                                                        <div className="pagination-container d-flex mt-4">
                                                            <Pagination
                                                                count={Math.ceil(finalCount / rowsPerPage)}
                                                                page={currentPage}
                                                                onChange={(event, newPage) => CheckPageInteractionHandleIndex(event, newPage)}
                                                                showFirstButton
                                                                showLastButton
                                                                siblingCount={isLgScreen ? 2 : 0}
                                                                boundaryCount={isLgScreen ? 2 : 1}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {isLgScreen ? 
                                                (<>
                                                    {interactionResults.data.generalDisclaimer && generalDisclaimer(interactionDisclaimer)}
                                                </>
                                                ):(
                                                <Alert variant="outlined" severity="info" style={{ marginTop: '20px', borderRadius:"16px" }}>
                                                    <AlertTitle color="error">Disclaimer:</AlertTitle>
                                                    
                                                    {/* Truncated Paragraph */}
                                                    <div style={{ display: 'webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden', WebkitLineClamp: 6, fontSize: '12px' }}>
                                                    {interactionResults.data.generalDisclaimer && generalDisclaimer(interactionDisclaimer)}
                                                    </div>

                                                    {/* View Full Disclaimer Button */}
                                                    <div style={{ marginTop: '8px' }}>
                                                        <Button 
                                                            variant="text" 
                                                            color="primary" 
                                                            style={{ padding: 0, fontSize: 12, fontWeight: "bold", textDecoration: 'underline' }}
                                                            size='small'
                                                            onClick={() => {
                                                                setActiveDisclaimer(interactionDisclaimer); // or interactionDisclaimer
                                                                setDisclaimerOpen(true);
                                                              }}
                                                        >
                                                            View full disclaimer
                                                        </Button>
                                                    </div>
                                                    {renderDisclaimerModal()}

                                                </Alert>
                                                
                                                )}
                                            </Box>
                                        )}

                                        {tabValue === 1 && (
                                        <Box pt={isLgScreen ? 2:0} style={{
                                                paddingTop:
                                                isTabsFloating && !isLgScreen
                                                ? noAllergyDisclaimer
                                                    ? "40px"
                                                    : "72px"
                                                : undefined
                                              }}>
                                        
                                        {isLgScreen && (
                                            <h4 className="align-self-start">Allergy Check Results</h4>
                                        )}
                                        {noAllergyDisclaimer ? (
                                        <div className="noResultAlert" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                             {!isLgScreen ? (
                                                    <>
                                                    <Row className='d-flex align-items-center' style={{ flexWrap: 'nowrap' }}>
                                                        <Col md={2} className='d-flex justify-content-center' style={{width:"fit-content"}}>
                                                            <IconInfoTriangleFilled size={32} style={{ color: '#0262AB' }} />
                                                        </Col>
                                                        <Col md={10} style={{ paddingRight: "8px", flex: 1 }}>
                                                            <span style={{ fontSize: "16px", fontWeight: "bold"}}>
                                                            No allergy warnings found
                                                            </span>
                                                        </Col>
                                                    </Row>

                                                    <Col md={12}>
                                                        <p style={{ margin: 0, fontSize:12 }}>
                                                            {parse(noAllergyDisclaimer.toString())}
                                                        </p>
                                                    </Col>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                            {/* Column 1: Icon */}
                                                            <IconInfoTriangleFilled size={92} color="#0061AA" style={{ marginRight: '16px', flexShrink: 0 }} />

                                                            {/* Column 2: Title and First Paragraph */}
                                                            <div style={{ flex: 1 }}>
                                                                {/* Title */}
                                                                <h4 style={{ margin: 0, marginBottom: 8, fontWeight: "bold" }}>No allergy warnings found</h4>
                                                                {/* AllergyDisclaimer */}
                                                                <p style={{ margin: 0 }}>
                                                                    {parse(noAllergyDisclaimer.toString())}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                        ) : (
                                            <>
                                            <div className={isTabsFloating ? "rowOptionsFloating " : "d-flex justify-content-between align-items-center w-100"}>
                                                <div className='custom-pagination'  style={{ flexGrow: 1, marginRight: 16 }}>
                                                    <TablePagination
                                                        style={{ fontSize: { xs: "12px", lg: "inherit" } }} // 12px on small screens, default on large
                                                        rowsPerPageOptions={
                                                            totalCountAllergy <= 5
                                                                ? [] // Hide rows per page when totalCountAllergy <= 5
                                                                : totalCountAllergy <= 10
                                                                ? [5, { label: "All", value: -1 }] // Show 5 and "All" when totalCountAllergy <= 10
                                                                : totalCountAllergy <= 25
                                                                ? [5, 10, { label: "All", value: -1 }] // Show 5, 10, and "All" when totalCountAllergy <= 25
                                                                : [5, 10, 25, { label: "All", value: -1 }] // Show all options when totalCount > 25
                                                        }
                                                        component="div"
                                                        count={totalCountAllergy}
                                                        rowsPerPage={rowsPerPage}
                                                        page={currentAllergyPage - 1}
                                                        onPageChange={(event, newPage) => CheckPageAllergyHandleIndex(event, newPage + 1)}
                                                        onRowsPerPageChange={(event) => {
                                                            const newRowsPerPage = parseInt(event.target.value, 10);
                                                            setRowsPerPage(newRowsPerPage);
                                                            setCurrentAllergyPage(1);
                                                            CheckPageAllergyHandleIndex(null, 1, newRowsPerPage);
                                                        }}
                                                        ActionsComponent={CustomPaginationActions}
                                                        labelRowsPerPage={isLgScreen ? "Rows per page" : "Rows"}
                                                        labelDisplayedRows={({ from, to, count }) => {
                                                                
                                                        // Non-filtered results
                                                        if (rowsPerPage === -1 || (count <= 5 && count > 1)) {
                                                            return `${!isLgScreen ? "" : "Showing "}${count} results`;
                                                        }
                                                        
                                                        if (count === 1) {
                                                            return `${!isLgScreen ? "" : "Showing "}1 result`;
                                                        }
                                                        
                                                        return `${!isLgScreen ? `${from}-${to} of ` : `Showing ${from}-${to} of `}${count} results`;

                                                        }}
                                                        
                                                        
                                                    />
                                                </div>
                                            </div>
                                            {AllergyResults.status === 200 && (
                                                <>
                                            {isLgScreen ? 
                                                (<>
                                                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                        <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                            <TableCell>Medicine</TableCell>
                                                            <TableCell>Known Allergy</TableCell>
                                                            <TableCell>Interaction</TableCell>
                                                            <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {AllergyResults.data.drugAllergies.map((val, index) => (
                                                            <TableRow
                                                                key={index}
                                                                onClick={() =>
                                                                handleTxtValueAllergy(
                                                                    val.prescribedMedicine.name ,
                                                                    val.allergen.name,
                                                                    val.summaryStatement,
                                                                    val.references
                                                                )
                                                                }
                                                                sx={{
                                                                cursor: "pointer",
                                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                                                }}
                                                            >
                                                                <TableCell component="th" scope="row" className="molecule">
                                                                {val.prescribedMedicine.name}
                                                                </TableCell>
                                                                <TableCell sx={{ fontWeight: "bold", color: "red" }}>
                                                                {val.allergen.name}
                                                                </TableCell>
                                                                <TableCell>{cleanUp(val.summaryStatement)}</TableCell>
                                                                <TableCell id="open">
                                                                <IconExternalLink color="#0262AB" size={16} />
                                                                </TableCell>
                                                            </TableRow>
                                                            ))}
                                                        </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </>):
                                                (<>
                                                        <Row className='mb-1 py-2'style={{ fontSize: 10, fontWeight: "bold", alignItems: "center", backgroundColor: "#dee2e6", marginTop: isTabsFloating ? "0" : "0.5rem"}}>
                                                            <Col xs={12} md={12}>
                                                                <span>Allergy Results</span>
                                                            </Col>
                                                        </Row>
                                                        {AllergyResults.data.drugAllergies.map((val, index) => (
                                                            <Row className='mobileRows'style={{ fontSize: 12 }}  key={index}
                                                            onClick={() =>
                                                            handleTxtValueAllergy(
                                                                val.prescribedMedicine.name,
                                                                val.allergen.name,
                                                                val.summaryStatement,
                                                                val.references
                                                            )
                                                            }>
                                                                <Row className='mb-2'>
                                                                    <Col xs={6} md={6}>
                                                                    
                                                                                <strong style={{fontSize: 8}}>Medicine</strong><br />
                                                                                <span style={{fontWeight: "bold", color: "#0262AB"}}>
                                                                                    {val.prescribedMedicine.name}
                                                                                </span>
                                                                    </Col>   
                                                                    <Col xs={6} md={6}>       
                                                                                <strong style={{fontSize: 8}}>Known Allergy</strong><br />
                                                                                <span style={{fontWeight: "bold", color: "red"}}>
                                                                                    {val.allergen.name}
                                                                                </span>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mb-2'>
                                                                    <Col xs={10} md={10}> 
                                                                                <strong style={{fontSize: 8}}>Interaction</strong><br />
                                                                                <span
                                                                                    style={{
                                                                                    fontSize: 10,
                                                                                    display: '-webkit-box',
                                                                                    WebkitLineClamp: 2,
                                                                                    WebkitBoxOrient: 'vertical',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis'
                                                                                    }}
                                                                                >
                                                                                {cleanUp(val.summaryStatement)}
                                                                                </span>
                                                                    </Col>
                                                                    <Col xs={2} md={2} style={{display: "flex", alignItems:"center", justifyContent: "end"}}>
                                                                        <IconArrowRight color="#0262AB" size={16} />
                                                                    </Col>
                                                                </Row>
                                                                <hr className='m-0'/>
                                                            </Row>
                                                        ))}
                                                </>)
                                            }
                                            </>
                                        )}
                                                <div className="pagination-container d-flex mt-4">
                                                    <Pagination
                                                        count={Math.ceil(totalCountAllergy / rowsPerPage)}
                                                        page={currentAllergyPage}
                                                        onChange={(event, newPage) => CheckPageAllergyHandleIndex(event, newPage)}
                                                        showFirstButton
                                                        showLastButton
                                                        siblingCount={isLgScreen ? 2 : 0}
                                                        boundaryCount={isLgScreen ? 2 : 1}
                                                    />
                                                </div>
                                            </>
                                        )}
                                         {isLgScreen ? 
                                                (<>
                                                    {interactionResults.data.generalDisclaimer && generalDisclaimer(allergyDisclaimer)}
                                                </>
                                                ):(
                                                <Alert variant="outlined" severity="info" style={{ marginTop: '20px', borderRadius:"16px" }}>
                                                    <AlertTitle color="error">Disclaimer:</AlertTitle>
                                                    
                                                    {/* Truncated Paragraph */}
                                                    <div style={{ display: 'webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden', WebkitLineClamp: 6, fontSize: '12px' }}>
                                                    {AllergyResults.data?.generalDisclaimer && generalDisclaimer(allergyDisclaimer)}
                                                    </div>

                                                    {/* View Full Disclaimer Button */}
                                                    <div style={{ marginTop: '8px' }}>
                                                    <Button 
                                                            variant="text" 
                                                            color="primary" 
                                                            style={{ padding: 0, fontSize: 12, fontWeight: "bold", textDecoration: 'underline' }}
                                                            size='small'
                                                            onClick={() => {
                                                                setActiveDisclaimer(allergyDisclaimer); // or interactionDisclaimer
                                                                setDisclaimerOpen(true);
                                                              }}
                                                        >
                                                            View full disclaimer
                                                        </Button>
                                                    </div>
                                                    {renderDisclaimerModal()}

                                                </Alert>
                                                
                                                )}
                                    </Box>
                                        )}
                                        <Zoom
                                        in={isTabsFloating}
                                        timeout={transitionDuration}
                                        unmountOnExit
                                        >
                                            <Fab
                                                color="primary"
                                                aria-label="add"
                                                sx={{
                                                position: 'fixed',
                                                bottom: 80,
                                                right: 20,
                                                zIndex: 100,
                                                backgroundColor: "#0262AB"
                                                }}
                                                onClick={handleOpenSearchDialog}
                                            >
                                                <IconSearch />
                                            </Fab>
                                        </Zoom>
                                    </Box>
                                    ) : (
                                    // If interactionResults.success is false, show this
                                        <div id="illustration-container">
                                            <h6>
                                            USE THE SEARCH FILTERS TO START YOUR INTERACTIONS CHECK.
                                            </h6>
                                            <img src={country === "New Zealand" ? InteractionsIllustrationNZ : InteractionsIllustration} alt="Illustration" id="illustration" />
                                        </div>
                                )}

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Zoom
                    in={isFloating && isLgScreen}
                    timeout={transitionDuration}
                    unmountOnExit
                    >
                        <Fab
                            color='primary'
                            aria-label="add"
                            sx={{
                            position: 'fixed',
                            bottom: 40,
                            right: 40,
                            zIndex: 100,
                            backgroundColor: theme.primary,
                            color: "#fff"
                            }}
                            variant="extended"
                            onClick={handleScrollUp}
                            size="medium"
                        >
                                <IconArrowBadgeUpFilled sx={{ mr: 2 }} />
                                Scroll Up
                        </Fab>
                    </Zoom>
            </Container>
        </div>
        <Dialog open={filterDialogOpen} onClose={handleCloseFilterDialog} fullWidth maxWidth="sm" id="filters" PaperProps={{
            sx: {
            maxWidth: muiTheme => `calc(${muiTheme.breakpoints.values.sm}px + 20px)`
            }
        }}>
            <DialogTitle>
                <div className='d-flex justify-content-between'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <IconFilterFilled size={20} /> Filter Results
                    </div>
                    {!isLgScreen && interactionResults.success === true ? (
                    <IconButton onClick={handleCloseFilterDialog}>
                        <IconX />
                    </IconButton>
                    ) : (
                        <Button
                        variant="text"
                        onClick={handleResetFilters}
                        color="error"
                        startIcon={<IconRestore />}
                        disabled={
                            // Disable if current filters match the ones calculated in handleResetFilters
                            JSON.stringify(severityFilters) === JSON.stringify({
                                5: severityCounts[5] > 0,
                                4: severityCounts[4] > 0,
                                3: severityCounts[3] > 0,
                                2: severityCounts[2] > 0,
                                all: Object.keys(severityCounts).filter(key => severityCounts[key] > 0).length === 4
                            }) &&
                            JSON.stringify(documentationFilters) === JSON.stringify({
                                1: documentationCounts[1] > 0,
                                2: documentationCounts[2] > 0,
                                3: documentationCounts[3] > 0,
                                4: documentationCounts[4] > 0,
                                all: Object.keys(documentationCounts).filter(key => documentationCounts[key] > 0).length === 4
                            })
                        }
                        >
                        Reset All
                        </Button>
                    )}
                    
                </div>
            </DialogTitle>
            <hr />
            <DialogContent>
                <div className='mb-3'>
                <span>
                    Total Results: <Chip label={totalCount} size="small" color="error" />
                </span>
                </div>
                <Row>
                {/* Severity Filters */}
                <Col lg={6} md={12} className={!isLgScreen ? "mb-3" : ""}>
                    <FormLabel sx={{ fontWeight: 'bold', mb: 1, fontSize: 12, display: 'block' }}>
                    BY SEVERITY TYPE:
                    </FormLabel>
                    <FormControl style={{fontSize: 12}}>
                    <Tooltip
                        title={
                            Object.values(severityCounts).filter((count) => count > 0).length < 4
                            ? 'Not all severity types are available' : ''
                        }
                        >
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={severityFilters.all}
                                onChange={() => handleSeverityChange('all')}
                                color="primary"
                                disabled={Object.values(severityCounts).filter((count) => count > 0).length < 4}
                            />
                            }
                            label={
                            <Box
                                sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color:
                                    Object.values(severityCounts).filter((count) => count > 0).length < 4
                                    ? 'text.disabled'
                                    : 'inherit',
                                }}
                            >
                                <strong>All</strong>
                            </Box>
                            }
                        />
                    </Tooltip>

                    <FormGroup sx={{ pl: 2 }} >
                        {[{ id: 5, label: 'Severe' }, { id: 4, label: 'Moderate' }, { id: 3, label: 'Minor' }, { id: 2, label: 'Caution' }].map(({ id, label }) => (
                        <FormControlLabel
                            key={id}
                            control={
                            <Checkbox
                                checked={severityFilters[id]}
                                onChange={() => handleSeverityChange(id)}
                                color="primary"
                                disabled={severityCounts[id] === 0}
                            />
                            }
                            label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {label} <Chip label={severityCounts[id]}  size="small" />
                            </Box>
                            }
                        />
                        ))}
                    </FormGroup>
                    </FormControl>
                </Col>

                {/* Documentation Filters */}
                <Col lg={6} md={12}>
                    <FormLabel sx={{ fontWeight: 'bold', mb: 1, fontSize: 12, display: 'block' }}>
                    WITH DOCUMENTATION LEVEL:
                    </FormLabel>
                    <FormControl>
                    <Tooltip
                        title={
                            Object.values(documentationCounts).filter((count) => count > 0).length < 4
                            ? 'Not all documentation levels are available' : ''
                        }
                        >
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={documentationFilters.all}
                                onChange={() => handleDocumentationChange('all')}
                                color="primary"
                                disabled={Object.values(documentationCounts).filter((count) => count > 0).length < 4}
                            />
                            }
                            label={
                            <Box
                                sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color:
                                    Object.values(documentationCounts).filter((count) => count > 0).length < 4
                                    ? 'text.disabled'
                                    : 'inherit',
                                }}
                            >
                                <strong>All</strong>
                            </Box>
                            }
                        />
                    </Tooltip>

                    <FormGroup sx={{ pl: 2 }}>
                        {[{ id: 4, label: 'Well Established' }, { id: 3, label: 'Good' }, { id: 2, label: 'Limited' }, { id: 1, label: 'Not Established' }].map(({ id, label }) => (
                        <FormControlLabel
                            key={id}
                            control={
                            <Checkbox
                                checked={documentationFilters[id]}
                                onChange={() => handleDocumentationChange(id)}
                                color="primary"
                                disabled={documentationCounts[id] === 0}
                            />
                            }
                            label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {label} <Chip label={documentationCounts[id]}  size="small" />
                            </Box>
                            }
                        />
                        ))}
                    </FormGroup>
                    </FormControl>
                </Col>
                </Row>
            </DialogContent>
            <DialogActions style={{ display: "flex", gap: "8px", width: "100%", flexWrap: "wrap", marginTop: "auto", borderTop: "1px solid #e3e3e3", paddingTop: 16 }}>

                {!isLgScreen && interactionResults.success === true && (
                <Button
                variant="text"
                onClick={handleResetFilters}
                color="error"
                sx={{ borderRadius: "8px", flex: "1" }}
                startIcon={<IconRestore size={16}/>}
                disabled={
                    // Disable if current filters match the ones calculated in handleResetFilters
                    JSON.stringify(severityFilters) === JSON.stringify({
                        5: severityCounts[5] > 0,
                        4: severityCounts[4] > 0,
                        3: severityCounts[3] > 0,
                        2: severityCounts[2] > 0,
                        all: Object.keys(severityCounts).filter(key => severityCounts[key] > 0).length === 4
                    }) &&
                    JSON.stringify(documentationFilters) === JSON.stringify({
                        1: documentationCounts[1] > 0,
                        2: documentationCounts[2] > 0,
                        3: documentationCounts[3] > 0,
                        4: documentationCounts[4] > 0,
                        all: Object.keys(documentationCounts).filter(key => documentationCounts[key] > 0).length === 4
                    })
                }
                >
                Reset
                </Button>
                )}
                <Button
                    variant="contained"
                    onClick={handleFilterChange}
                    color="primary"
                    sx={{ borderRadius: "8px", marginLeft: "auto", flex: isLgScreen ? "":"1" }}
                    disabled={
                        // Check if no changes have been made since the last applied filters
                        (
                        Object.entries(severityFilters)
                            .filter(([k, v]) => k !== 'all' && v) // Filter out 'all' option and keep only selected severity levels
                            .map(([k]) => Number(k)) // Get selected severity levels as numbers
                            .sort()
                            .toString() === appliedSeverities.slice().sort().toString() // Compare with last applied severity filters
                        &&
                        Object.entries(documentationFilters)
                            .filter(([k, v]) => k !== 'all' && v) // Filter out 'all' option and keep only selected documentation levels
                            .map(([k]) => Number(k)) // Get selected documentation levels as numbers
                            .sort()
                            .toString() === appliedDocs.slice().sort().toString() // Compare with last applied documentation filters
                        ) ||
                        // Check if no severities are selected
                        Object.entries(severityFilters)
                        .filter(([k, v]) => k !== 'all' && v)
                        .length === 0 || 
                        // Check if no documentation levels are selected
                        Object.entries(documentationFilters)
                        .filter(([k, v]) => k !== 'all' && v)
                        .length === 0
                    }
                    >
                         { isLgScreen ? "Apply Filters" : "Apply" }
                </Button>
            </DialogActions>
        </Dialog>

    </>
    );
}

export default DrugAllergyInteractions;